// import { useTranslation } from "react-i18next";
import { Avatar, Icon, Tooltip } from "@material-ui/core";
import Ticket from "./Ticket";

import "./ServiceStatusOfTodayBox.scss";
import { useTranslation } from "react-i18next";

export const ServiceStatusOfTodayBox = ({ technician }) => {
  const { technician: person, services } = technician;
  const { t } = useTranslation();
  return (
    <div className="box">
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center boxName">
          <Avatar
            sx={{
              width: 30,
              height: 30,
              fontSize: "0.9rem",
              bgcolor: "var(--BMX-primary)",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            style={{ marginRight: "5px" }}
            //  src={user?.profileImage}
          >
            {`${person.firstName?.toUpperCase().slice(0, 1) || ""}${
              person.lastName?.toUpperCase().slice(0, 1) || ""
            }`}
          </Avatar>
          <h6 className="mb-0">
            {person.firstName} {person.lastName}
          </h6>
          {technician.lastTaskActive && (
            <div style={{ marginLeft: "10px" }}>
              <Tooltip
                className="d-flex flex-column  align-items-center"
                title={t("global:service.lastServiceCondition")}
                placement="top"
              >
                <Icon>sports_score</Icon>
              </Tooltip>
            </div>
          )}
        </div>

        <div className="d-flex flex-column pt-5">
          {services.map((service) => (
            <Ticket key={service.index} service={service} />
          ))}
        </div>
      </div>
    </div>
  );
};
